const RANGE_SEPARATOR = "/";
const MULTIPLE_SEPARATOR = ",";
export function compareIso(a, b) {
  return a.localeCompare(b);
}
export function normalizeRange(start, end) {
  if (compareIso(start, end) <= 0) {
    return {
      start,
      end
    };
  }
  return {
    start: end,
    end: start
  };
}
export function parseIsoRange(value) {
  if (!value) {
    return null;
  }
  const [start, end] = value.split(RANGE_SEPARATOR);
  if (!start || !end) {
    return null;
  }
  return normalizeRange(start, end);
}
export function serializeIsoRange(range) {
  if (!range) {
    return "";
  }
  const normalized = normalizeRange(range.start, range.end);
  return `${normalized.start}${RANGE_SEPARATOR}${normalized.end}`;
}
export function parseMultipleIsos(value) {
  if (!value) {
    return [];
  }
  return value.split(MULTIPLE_SEPARATOR).map(iso => iso.trim()).filter(Boolean).sort(compareIso);
}
export function serializeMultipleIsos(values) {
  return [...new Set(values)].sort(compareIso).join(MULTIPLE_SEPARATOR);
}
export function toggleMultipleIso(selected, iso) {
  const set = new Set(selected);
  if (set.has(iso)) {
    set.delete(iso);
  } else {
    set.add(iso);
  }
  return [...set].sort(compareIso);
}
export function isIsoInSpan(iso, range) {
  const normalized = normalizeRange(range.start, range.end);
  return compareIso(iso, normalized.start) >= 0 && compareIso(iso, normalized.end) <= 0;
}
export function getActiveRangeBounds(committed, draft) {
  if (draft.anchor) {
    const hover = draft.hover ?? draft.anchor;
    return normalizeRange(draft.anchor, hover);
  }
  return committed;
}
export function getDaySelectionAppearance(iso, mode, options) {
  if (mode === "single") {
    const selected = options.singleIso === iso;
    return {
      isSelected: selected,
      isRangeStart: selected,
      isRangeEnd: selected,
      isRangeMiddle: false
    };
  }
  if (mode === "multiple") {
    const selected = options.multipleIsos?.includes(iso) ?? false;
    return {
      isSelected: selected,
      isRangeStart: selected,
      isRangeEnd: selected,
      isRangeMiddle: false
    };
  }
  const range = options.range;
  if (!range) {
    return {
      isSelected: false,
      isRangeStart: false,
      isRangeEnd: false,
      isRangeMiddle: false
    };
  }
  const normalized = normalizeRange(range.start, range.end);
  const inSpan = isIsoInSpan(iso, normalized);
  const isStart = iso === normalized.start;
  const isEnd = iso === normalized.end;
  const isMiddle = inSpan && !isStart && !isEnd;
  return {
    isSelected: inSpan,
    isRangeStart: isStart,
    isRangeEnd: isEnd,
    isRangeMiddle: isMiddle
  };
}
export function advanceRangeSelection(committed, draft, iso) {
  if (!draft.anchor) {
    return {
      committed,
      draft: {
        anchor: iso,
        hover: iso
      }
    };
  }
  const next = normalizeRange(draft.anchor, iso);
  return {
    committed: next,
    draft: {
      anchor: null,
      hover: null
    }
  };
}